import { Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { UserAvatar } from "minimals-template/components/user-avatar"

export function UserAccessOverflowRow({ item }) {
    return (
        <ListItemBox sx={{ gap: 1 }}>
            <UserAvatar user={item} sx={{ width: 24, height: 24, "& .MuiTypography-root": { fontSize: "12px" } }} />
            <Typography variant="body2" noWrap>
                {getName()}
            </Typography>
        </ListItemBox>
    )

    function getName() {
        return item?.displayName ?? item?.metadata?.displayName ?? "Unknown User"
    }
}
